import TextInput from '@/components/form/text-input';
import { Stack, Theme } from '@mui/material';
import { FC } from 'react';
import { SegmentFieldBaseProps } from './helpers';
import { createUseStyles } from 'react-jss';
import SegmentFieldBase from './base';

interface Props extends Omit<SegmentFieldBaseProps, 'rightContent' | 'onClear'> {
  name: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

const useStyles = createUseStyles((theme: Theme) => ({
  inputSegment: {
    '& .MuiInputBase-root': {
      borderRadius: 0,
      height: 26,
      minHeight: 26,
      padding: '0px 8px',
      backgroundColor: theme.palette.common.white,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '& .MuiInputBase-input': {
      fontSize: 12,
      padding: 0,
      height: 26,
      minWidth: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  },
}));

const SegmentFieldSearch: FC<Props> = ({ name, value, onChange, placeholder, ...rest }) => {
  const styles = useStyles();
  const showClear = !!value.trim().length;

  return (
    <SegmentFieldBase
      {...rest}
      variant="search"
      onClear={showClear ? () => onChange('') : undefined}
      rightContent={
        <Stack className={styles.inputSegment} width="100%">
          <TextInput
            name={name}
            value={value}
            onChange={onChange}
            size="x-small"
            placeholder={placeholder}
          />
        </Stack>
      }
    />
  );
};

export default SegmentFieldSearch;
